module.exports = __webpack_public_path__ + "img/XAI-alt.aef387b3.svg";